import { createFileRoute } from '@tanstack/react-router'

import { loadByStockRedirect } from '@/screens/brokers/ByStockRedirect.loader'

/**
 * `/brokers/by-stock` — the sidebar's "By stock" row with no symbol in view.
 *
 * The loader always throws (a redirect, or an error the default
 * `RouteErrorPage` turns into a page rather than a blank one — see its own
 * doc comment), so `component` never renders on a real visit. It exists
 * because a virtual route needs one, and it stands in only for the instant
 * between a slow default lookup and the redirect landing — the router's
 * `defaultPendingComponent` (`PendingPage`) covers that, unstyled, on
 * purpose: there is no "By stock" layout to promise here, only a pass-through.
 */
export const Route = createFileRoute('/_app/brokers/by-stock')({
  loader: loadByStockRedirect,
  component: () => null,
})
